import React from 'react';
import { withRouter } from "react-router-dom";
import {webFont} from "../config/theme";

const Breadcrumbs = (props) => {
  const handleClick = (routeName) => {
    if (routeName !== '#') {
      props.history.push(`/${routeName}`)
    }
  }

  const pathname = props.location && props.location.pathname ? props.location.pathname.substr(1) : '';

  return (
    <div className="breadcrumb-parent">
      <span
        style={styles.linkSelected}
        onClick={() => handleClick('home/dashboard')}>
        Home
      </span>
      {props.childRoutes.map((childRoute, index) => (
        <React.Fragment>
          <span style={styles.separator}> > </span>
          <span
            style={styles.linkSelected}
            onClick={() => (index !== props.childRoutes.length - 1) && handleClick(childRoute.link)}>
            {childRoute.display}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

export default withRouter(Breadcrumbs);

const styles = {
  parent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0px 0px 5px'
  },
  link: {
    fontFamily: webFont,
    color: '#ccc',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    cursor: 'pointer'
  },
  linkSelected: {
    fontFamily: webFont,
    color: '#ff8000',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    cursor: 'pointer'
  },
  separator: {
    fontSize: 15,
    color: '#ff8000',
    margin: '0 7px'
  },
};
